module.exports = __webpack_public_path__ + "img/logo_dark.ac8cab5a.png";